<template>
    <div id="duixiang">
            <el-main>
                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-input v-model="duixiang_name_kw" @blur="searchByname(duixiang_name_kw)" @keyup.enter.native="searchByname(duixiang_name_kw)" @input="searchByname(duixiang_name_kw)" size="mini" placeholder="对象名关键字查找" />
                    </el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="2">
                        <h5>选择标签查找</h5>
                    </el-col>
                </el-row>
                <Tag color="teal" @click.native="showAll">显示全部</Tag>
                <Tag v-for="(tag, index) in tags" checkable :checked="tag['is_checked'] ? true : false" @click.native="searchByTag(tag, index)" class="tag" color="#008080" :key="index">{{tag.tag_name}}</Tag>
                <el-table :data="cur_page_duixiangs" border style="width: 100%" v-loading="loading">
                    <el-table-column label="对象名" width="150">
                        <template slot-scope="scope">
                            <span>{{ scope.row.duixiang_name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.duixiang_phone_num }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标签" width="350">
                        <template slot-scope="scope">
                            <span v-for="item in scope.row.tags">
                                <el-tag class="el-tag" size="small" type="info">{{item.tag_name}} </el-tag type="info">
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot="header" slot-scope="scope">
                            操作
                        </template>
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination :current-page="page.cur_page" :page-size="page.page_size" layout="prev, pager, next" :total="page.total" @current-change="currentChange">
                    </el-pagination>
                </div>
                <el-dialog title="修改对象" :visible.sync="dialogVisible">
                    <el-form>
                        <el-form-item label="对象名">
                            <el-input autocomplete="off" v-model="duixiang_edit.duixiang_name"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input autocomplete="off" v-model="duixiang_edit.duixiang_phone_num"></el-input>
                        </el-form-item>
                    </el-form>
                    <Tag v-for="(tag, index) in tags" checkable :checked="tag['is_checked'] ? true : false" @click.native="handleClickTag(index, tag)" class="tag" color="#008080" :key="index">{{tag.tag_name}}</Tag>
                    <template v-if="inputVisible">
                        <el-input class="input-new-tag" v-model="input_tag" ref="saveTagInput" size="small" @blur="handleInputConfirm" @keyup.enter.native="$event.target.blur">
                            <template slot="append">
                                <el-button class="button-new-tag" size="small" @click="handleInputConfirm">添加标签</el-button>
                            </template>
                        </el-input>
                    </template>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新 标 签</el-button>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleCancel">取 消</el-button>
                        <el-button type="primary" @click="handleSubmit">修 改</el-button>
                    </div>
                </el-dialog>
            </el-main>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../../config.js'
import { Tag } from 'iview';
export default {
    components: {
        Tag,
    },
    props: ['group_id'],
    data() {
        return {
            group: {
                group_id: '',
                group_name: ''
            },
            duixiangs: [],
            tags: [],
            dialogVisible: false,
            duixiang_edit: {
                duixiang_id: '',
                index: '',
                duixiang_name: '',
                duixiang_phone_num: '',
                tags_ids: []
            },
            inputVisible: false,
            input_tag: '',
            page: {
                cur_page: 1,
                total: 0,
                page_size: 10

            },
            cur_page_duixiangs: [],
            showing_duixiangs: [],
            duixiang_name_kw: '',
            loading: false,
            tags_ids: []
        }

    },
    created() {
        this.group.group_id = this.group_id
        this.getGroup()
        this.getDuixiang()
        this.getTags()
    },
    methods: {
        getTags() {
            //console.log('getTags')
            let url = config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                this.tags = response.data
            })
        },
        getGroup() {
            let url = config.base_url + '/yun_table/yun_duixiang_groups/' + this.group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.group.group_id = res.group_id
                this.group.group_name = res.group_name
            }).catch((err) => {
                //console.log(err);
            })
        },
        getDuixiang() {
            this.loading = true
            let url = config.base_url + '/yun_table/yun_duixiang?group_id=' + this.group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.duixiangs = res
                this.page.total = res.length
                this.showing_duixiangs = res
                this.showCurDuixiang()
                this.loading = false
            })
        },

        getTag(duixiang_id) {
            let url = config.base_url + '/yun_table/yun_duixiang/' + duixiang_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.duixiang_edit.tags = res.tags
                let edit_tags = this.duixiang_edit.tags
                for (let i = 0; i < edit_tags.length; i++) {
                    this.tags_ids.push(edit_tags[i].tag_id)
                }

                let tags = this.tags
                let tags_ids = this.tags_ids
                for (let i = 0; i < tags.length; i++) {
                    for (let j = 0; j < tags_ids.length; j++) {
                        if (tags_ids[j] == tags[i].tag_id) {
                            this.tags[i]['is_checked'] = true
                        } else {
                            this.tags[i]['is_checked'] = false
                        }
                    }
                }

            })
        },
        handleEdit(index, duixiang) {
            this.dialogVisible = true
            //console.log(duixiang)
            this.duixiang_edit.duixiang_name = duixiang.duixiang_name
            this.duixiang_edit.duixiang_phone_num = duixiang.duixiang_phone_num
            this.duixiang_edit.duixiang_id = duixiang.duixiang_id
            this.duixiang_edit.index = index
            for (let i = 0; i < duixiang.tags.length; i++) {
                this.duixiang_edit.tags_ids.push(duixiang.tags[i].tag_id)
            }
            let tags = this.tags
            let edit_tags = this.duixiang_edit.tags_ids
            for (let i = 0; i < tags.length; i++) {
                tags[i]['is_checked'] = false
            }
            for (let i = 0; i < tags.length; i++) {
                if (this.inArray(tags[i].tag_id, edit_tags)) {
                    tags[i]['is_checked'] = true
                }
            }



        },
        inArray(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return true
                }
            }
        },
        arrIndex(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return i
                }
            }
            return -1
        },

        handleCancel() {
            this.dialogVisible = false
            this.duixiang_edit.duixiang_id = ''
            this.duixiang_edit.duixiang_name = ''
            this.duixiang_edit.duixiang_phone_num = ''
            this.duixiang_edit.tags_ids = []
        },
        handleClickTag(index, tag) {
            //console.log(tag)
            if (tag.is_checked) {
                this.tags[index]['is_checked'] = false
                let ind = this.arrIndex(tag.tag_id, this.duixiang_edit['tags_ids'])
                if (ind != -1) {
                    this.duixiang_edit['tags_ids'].splice(ind, 1)
                }
            } else {
                this.tags[index]['is_checked'] = true
                this.duixiang_edit['tags_ids'].push(tag.tag_id)
            }
            //console.log(tag)

        },
        handleSubmit() {
            let data = this.duixiang_edit

            let index = data.index
            let url = config.base_url + '/yun_table/yun_duixiang/' + data.duixiang_id + '?group_id=' + this.group.group_id
            axios({
                    method: 'put',
                    url: url,
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    data: data
                })
                .then((response) => {
                    this.dialogVisible = false
                    this.dialogVisible = false


                    let dxs = this.duixiangs
                    for (let i = 0; i < dxs.length; i++) {
                        if (dxs[i].duixiang_id == response.data.duixiang_id) {
                            this.duixiangs[i].duixiang_name = response.data.duixiang_name
                            this.duixiangs[i].duixiang_id = response.data.duixiang_id
                            this.duixiangs[i].duixiang_phone_num = response.data.duixiang_phone_num
                            this.duixiangs[i].tags = response.data.tags
                        }
                    }

                    let cdxs = this.cur_page_duixiangs
                    for (let i = 0; i < cdxs.length; i++) {
                        if (dxs[i].duixiang_id == response.data.duixiang_id) {
                            this.cur_page_duixiangs[i].duixiang_name = response.data.duixiang_name
                            this.cur_page_duixiangs[i].duixiang_id = response.data.duixiang_id
                            this.cur_page_duixiangs[i].duixiang_phone_num = response.data.duixiang_phone_num
                            this.cur_page_duixiangs[i].tags = response.data.tags
                        }
                    }

                    this.duixiang_edit.duixiang_id = ''
                    this.duixiang_edit.index = ''
                    this.duixiang_edit.duixiang_name = ''
                    this.duixiang_edit.duixiang_phone_num = ''
                    this.duixiang_edit.tags_ids = []

                    this.$message({
                        message: '对象修改成功',
                        type: 'success'
                    });


                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },
        handleInputConfirm() {
            let _this = this
            //console.log(this.input_tag)
            axios({
                    method: 'post',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.group.group_id,
                    data: {
                        tag_name: this.input_tag
                    }
                })
                .then(function(response) {
                    //console.log(response)
                    _this.tags.push(response.data)
                    _this.input_tag = ''
                    _this.$message({
                        message: '标签新增成功',
                        type: 'success'
                    });
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                    _this.input_tag = ''
                })
            this.inputVisible = false
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        currentChange(cur_page) {
            //console.log(cur_page)
            this.page.cur_page = cur_page
            this.showCurDuixiang()

        },
        showCurDuixiang() {
            let cur_page = this.page.cur_page
            //console.log(cur_page)
            let page_size = this.page.page_size
            let duixiangs = this.duixiangs
            let showing_duixiangs = this.showing_duixiangs
            this.cur_page_duixiangs = []
            if (showing_duixiangs.length > 0) {
                //cur_page = 1
                this.page.total = showing_duixiangs.length
                let cur_page_duixiangs = showing_duixiangs.slice((cur_page - 1) * page_size, (cur_page - 1) * page_size + page_size)
                this.cur_page_duixiangs = cur_page_duixiangs
            }
            //else {

            //     this.page.total = duixiangs.length
            //     this.cur_page_duixiangs = []
            //     let cur_page_duixiangs = duixiangs.slice((cur_page - 1) * page_size, (cur_page - 1) * page_size + page_size)
            //     this.cur_page_duixiangs = cur_page_duixiangs
            // }

        },
        searchByname(kw) {
            //console.log(kw)
            if (!kw) {
                this.showAll()
                return false
            }
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            if (kw) {
                //this.cur_page_duixiangs = []
                this.showing_duixiangs = []
                let patten = new RegExp(kw)
                for (let i = 0; i < duixiangs.length; i++) {
                    if (patten.test(duixiangs[i].duixiang_name)) {
                        //this.cur_page_duixiangs.push(duixiangs[i])
                        this.showing_duixiangs.push(duixiangs[i])
                    }
                }
            }
            this.duixiang_name_kw = ''
            this.showCurDuixiang()

        },
        handleDelete(index, duixiang) {
            this.$confirm('此操作将删除该对象, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios({
                        method: 'delete',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_duixiang/' + duixiang.duixiang_id
                    }).then((response) => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.cur_page_duixiangs.splice(index, 1);
                        let dxs = this.duixiangs
                        for (let i = 0; i < dxs.length; i++) {
                            if (dxs[i].duixiang_id == duixiang.duixiang_id) {
                                this.duixiangs.splice(i, 1)
                            }
                        }
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        showAll() {
            //this.showing_duixiangs = []
            this.showing_duixiangs = this.duixiangs
            this.page.cur_page = 1
            this.showCurDuixiang()
            this.tags_ids = []
            for (let i = 0; i < this.tags.length; i++) {
                this.tags[i].is_checked = false
            }
        },
        searchByTag(tag, index) {
            let tags_ids = this.tags_ids
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            //console.log(index)
            function hasTag() {
                if (tags_ids.length > 0) {
                    for (let i = 0; i < tags_ids.length; i++) {
                        if (tags_ids[i] == tag.tag_id) {
                            return true
                        }
                    }
                }
                return false
            }
            if (hasTag()) {
                //console.log(index)
                this.tags_ids.splice(this.arrIndex(tag.tag_id, tags_ids), 1)
                this.tags[index].is_checked = false
                if (this.tags_ids.length < 1) {
                    this.showAll()
                    return false
                }

                //console.log(t)
            } else {
                this.tags_ids.push(tag.tag_id)
                this.tags[index].is_checked = true
            }
            this.showing_duixiangs = []
            for (let i = 0; i < duixiangs.length; i++) {
                if (duixiangs[i].tags.length < 1) {
                    continue;
                }
                let dx_tag_id = []
                for (let j = 0; j < duixiangs[i].tags.length; j++) {
                    dx_tag_id.push(duixiangs[i].tags[j].tag_id)
                    // if(this.inArray(duixiangs[i].tags[j].tag_id, tags_ids)){
                    //  this.showing_duixiangs.push(duixiangs[i])
                    // }
                }
                if (this.arrInArray(this.tags_ids, dx_tag_id)) {
                    this.showing_duixiangs.push(duixiangs[i])
                }

            }
            this.showCurDuixiang()

        },
        arrInArray(arr1, arr2) {
            if (arr1.length < 1) {
                return false
            }
            for (let i = 0; i < arr1.length; i++) {
                if (!this.inArray(arr1[i], arr2)) {
                    return false
                }
            }
            return true
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>